"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var hocs_1 = require("../hocs");
var StyledTaskTileItem_1 = require("./StyledTaskTileItem");
var TaskTileInner = /** @class */ (function (_super) {
    tslib_1.__extends(TaskTileInner, _super);
    function TaskTileInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskTileInner.prototype.render = function () {
        var _a = this.props, icon = _a.icon, title = _a.title, linkText = _a.linkText;
        return (React.createElement(StyledTaskTileItem_1.StyledTaskTile, { pad: "medium", margin: { bottom: 'medium' } },
            React.createElement(StyledTaskTileItem_1.StyledIconWrapper, null,
                React.createElement(StyledTaskTileItem_1.StyledIcon, { src: icon })),
            React.createElement(StyledTaskTileItem_1.StyledTextWrapper, { margin: { left: 'small' } },
                React.createElement(StyledTaskTileItem_1.StyledTaskTitle, null, title),
                React.createElement(StyledTaskTileItem_1.StyledTaskText, null, linkText))));
    };
    return TaskTileInner;
}(React.PureComponent));
/** @component */
exports.TaskTile = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(TaskTileInner);
//# sourceMappingURL=TaskTile.js.map